module.exports = __webpack_public_path__ + "img/epr-article-top-img_small@2x.260a849b.webp";